<template>
  <v-dialog v-model="openedDialog" max-width="70%" scrollable eager>
    <template #activator="{ on }">
      <mf-button label="Conheça o CBM Mercafacil" v-on:click.native="on.click" />
    </template>

    <div class="get-cbm-container">
      <div class="side-container left-content">
        <div class="title-container">
          <span class="content-title">Veja as vantagens:</span>
          <span class="content-subtitle">O CBM da Mercafacil permite que você:</span>
        </div>
        <div class="benefits-list">
          <div v-for="benefit in benefits" :key="benefit" class="benefit-item">
            <div class="benefit-icon-container">
              <mf-icon fill color="#D4FF00">check_circle</mf-icon>
            </div>
            <div class="benefit-title-container">
              <span>{{ benefit }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="side-container right-content">
        <mf-button style="align-self: self-end; margin-right: -22px" color="cinza-0" type="icon" icon="close" size="sm" @click="() => (openedDialog = false)" />

        <div class="title-container">
          <span class="content-title">Obtenha o <b>CBM</b></span>
          <span class="content-subtitle">Seu supermercado precisa do CBM para crescer!</span>
          <span class="content-subtitle">Crie ações assertivas para atrair, reter e fidelizar seus clientes.</span>
        </div>

        <div id="modal-cbm-51ee2f0d290d7eecd782" role="main"></div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
const createRdForm = async () => {
  await new window.RDStationForms('modal-cbm-51ee2f0d290d7eecd782', 'UA-49188935-3').createForm()
}

export default {
  name: 'GetCbmFormModal',
  data: () => ({
    openedDialog: false,
    benefits: [
      'Aumente em até 30% a retenção dos seus clientes;',
      'Identifique até 95% dos seus clientes;',
      'Garanta um ticket médio até 150% maior dos seus clientes fidelizados;',
      'Melhore a experiência de compra do seu cliente pelos canais físicos e digitais;',
      'Se comunique com seus clientes por SMS, WhatsApp, push de aplicativo e e-mail.',
    ],
  }),
  mounted() {
    let rdstationScript = document.createElement('script')
    rdstationScript.setAttribute('src', 'https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js')
    document.head.appendChild(rdstationScript)

    rdstationScript.addEventListener('load', createRdForm)
  },
  beforeDestroy() {
    document.removeEventListener('load', createRdForm)
  },
}
</script>

<style lang="scss" scoped>
.get-cbm-container {
  background: #fff;
  display: flex;
  flex-direction: row;
  height: 100%;

  .side-container {
    display: flex;
    flex-direction: column;
    padding: 14px 36px;
    flex: 1;

    .title-container {
      display: flex;
      flex-direction: column;
      min-height: 120px;
      gap: 8px;
    }

    .content-title {
      margin-bottom: 24px;
      font-size: 36px;
    }

    .content-subtitle {
      font-style: normal;
      font-weight: 300;
      font-size: 18px;
      line-height: 120%;
    }
  }

  .left-content {
    background-color: #002040;
    color: #fff;
    gap: 24px;
    padding-top: 40px;

    .content-title {
      font-weight: 700;
    }

    .content-subtitle {
      color: #cacaca;
    }

    .benefits-list {
      display: flex;
      flex-direction: column;
      gap: 32px;

      .benefit-item {
        display: flex;
        flex-direction: row;

        .benefit-icon-container {
          display: flex;
          align-items: center;
          margin-right: 16px;
        }

        .benefit-title-container {
          font-size: 18px;
        }
      }
    }
  }

  .right-content {
    flex: 1.3;

    .content-title {
      color: #002040;
    }

    .content-subtitle {
      font-weight: 400;
      color: #002040;
    }
  }
}
</style>
